import * as DriverInformationPermitFields from '@src/permitField/DriverInformationFields';
import { BooleanField } from '@src/permitField/PermitFields';

export class DriverNameField extends BooleanField {
  public static fieldName: string =
    DriverInformationPermitFields.DriverNameField.fieldName;
}

export class DriverPhoneNumberField extends BooleanField {
  public static fieldName: string =
    DriverInformationPermitFields.DriverPhoneField.fieldName;
}

export class DriverEmailField extends BooleanField {
  public static fieldName: string =
    DriverInformationPermitFields.DriverEmailField.fieldName;
}

export class DriverLicenseNumberField extends BooleanField {
  public static fieldName: string =
    DriverInformationPermitFields.DriverLicenseNumberField.fieldName;
}
